(function($) {

    //---------------------
    // Set variables for this document
    //---------------------
    var menuOpened = false;
    var navHeight = $(".nav").outerHeight();
    var infoHeight = 0;
    var fullHeight = navHeight;
    if ($(".info-bar").length) {
        infoHeight = $(".info-bar").height();
        fullHeight = fullHeight + infoHeight;
    }



    //---------------------
    // Set variables for css on load and resize
    //---------------------
    document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
    document.documentElement.style.setProperty('--nav-height', `${navHeight}px`);
    document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
    var w = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == w) return;
        w = $(window).width();
        navHeight = $(".nav").outerHeight();
        fullHeight = navHeight;
        infoHeight = 0;
        if ($(".info-bar").length) {
            infoHeight = $(".info-bar").height();
            fullHeight = fullHeight + infoHeight;
        }
        document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
        document.documentElement.style.setProperty('--nav-height', `${navHeight}px`);
        document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
    });




    //Desktop menu hover
    let hoverTimer;
    let lastTarget = null;

    function openSideMenuDesktop(el) {
        const $link = $(el);
        const $side = $link.next('.nav_m__side');

        if ($link.hasClass('first')) {
            $('.nav_m__main_link-child').removeClass('-active');
        }
        $link.siblings('.nav_m__main_link-child').removeClass('-active');
        $link.addClass('-active');

        if ($side.hasClass('-hover-open')) return;

        if ($link.hasClass('first')) {
            $('.nav_m__side').removeClass('-hover-open');
        } else {
            $('.third.nav_m__side').removeClass('-hover-open');
        }
        $side.addClass('-hover-open');
    }

    $('.nav_m__more_menu-items, .nav_m__main_link:not(.nav_m__main_link-child)').on('pointerenter', function () {
        clearTimeout(hoverTimer);
        const el = this;
        lastTarget = el;
        hoverTimer = setTimeout(function () {
            if (lastTarget === el) {
                $('.nav_m__main_link-child').removeClass('-active');
                $('.nav_m__side').removeClass('-hover-open');
            }
        }, 100);
    }).on('pointerleave', function () {
        clearTimeout(hoverTimer);
        lastTarget = null;
    });

    $('.second .nav_m__main_link:not(.nav_m__main_link-child)').on('pointerenter', function () {
        clearTimeout(hoverTimer);
        const el = this;
        lastTarget = el;
        hoverTimer = setTimeout(function () {
            if (lastTarget === el) {
                $(el).siblings('.nav_m__main_link-child').removeClass('-active');
                $(el).siblings('.nav_m__side').removeClass('-hover-open');
            }
        }, 100);
    }).on('pointerleave', function () {
        clearTimeout(hoverTimer);
        lastTarget = null;
    });

    $('.nav_m__main_link-child').on('pointerenter', function () {
        clearTimeout(hoverTimer);
        const el = this;
        lastTarget = el;
        hoverTimer = setTimeout(function () {
            if (lastTarget === el) {
                openSideMenuDesktop(el);
            }
        }, 100);
    }).on('pointerleave', function () {
        clearTimeout(hoverTimer);
        lastTarget = null;
    });

    $('.nav_m__main_link-child').on('click', function (e) {
        // e.preventDefault();
        clearTimeout(hoverTimer);
        openSideMenuDesktop(this);
    });



    let mode = getComputedStyle(document.documentElement).getPropertyValue('--mode').trim();
    $(document).on("pointerdown", function (e) {
        if (e.pointerType === "touch") {
            mode = "button";
        }
    });
    $(document).on("touchstart", function (e) {
        mode = "button";
    });

//Menu items click
    $('.nav_m__main_link-child').click(function (e){

        if (mode === 'button') {
            e.preventDefault();
        }
        if ($(this).next('.nav_m__side').hasClass('nav_m__side-open')){
            $(this).next('.nav_m__side-open').find('.nav_m__side-open').removeClass('nav_m__side-open');
            $(this).next('.nav_m__side-open').removeClass('nav_m__side-open');
        } else {
            if ($(this).hasClass('first')) {
                $('.nav_m__side').removeClass('nav_m__side-open');
            }
            $(this).next('.nav_m__side').addClass('nav_m__side-open');
        }
    });

    $('.nav_m__side_back').click(function (){
        $(this).closest('.nav_m__side').removeClass('nav_m__side-open');
    });


    //---------------------
    // Set sub menu left offset if overflows document
    //---------------------
    function setNavOffset() {
        $('.navigation__items > .navigation__item').each(function() {
            var $this = $(this);
            var $linksWidth = $(this).children('.navigation__submenu').outerWidth();
            var $documentWidth = $(window).outerWidth();
            var $offset = $(this).offset().left;
            var left = ($documentWidth - $offset) - $linksWidth - 15;
            if ($linksWidth > $documentWidth - $offset) {
                $this.children('.navigation__submenu').css('left', left)
            } else {
                $this.children('.navigation__submenu').css('left', '')
            }
        });
    }


    //---------------------
    // On scroll functions
    //---------------------
    let lastScroll = 0;
    $(window).on('scroll',function() {
        var scroll = $(window).scrollTop();

        if(scroll > fullHeight) {
            // $('body').css('padding-top', navHeight)
            $(".nav").addClass("scrolled");
            setTimeout(function() {
                $('.nav').addClass("nav--animate");
            }, 200);
        } else {
            $(".nav").removeClass("scrolled");
            $('.nav').removeClass("nav--animate");
            // $('body').css('padding-top', '')
        }
        if(lastScroll - scroll > 0 && scroll > fullHeight) {
            $(".nav").addClass("scrollUp ");
        } else if (lastScroll - scroll < 0) {
            $(".nav").removeClass("scrollUp");
        }
        if(scroll > infoHeight) {
            $('.nav').removeClass("nav--top");
            $(".nav__sidebar").addClass("nav__sidebar-scrolled");
        } else {
            $('.nav').addClass("nav--top");
            $(".nav__sidebar").removeClass("nav__sidebar-scrolled");
        }
        lastScroll = scroll;

        // navAnimationClasses();
    });




    // $('.nav_m__header_link').on('click', function(e){
    //     let id = $(this).data('nav-open-category');
    //     if (!$(this).hasClass('active')){
    //         e.preventDefault();
    //         $('.nav_m__header_link').removeClass('active');
    //         $(this).addClass('active');
    //         $('.nav_m__main').removeClass('nav_m__main-active');
    //         $("[data-nav-category=" + id + "]").addClass('nav_m__main-active');
    //     } else {
    //
    //     }
    // });


    function onTouchNav() {
        var isTouchDevice = 'ontouchstart' in document.documentElement;

        if (isTouchDevice) {
            var lastTouchedLink = null;
            $('.nav__main_link-child').each(function(){
                $(this).on('touchstart', function(e) {
                    var $this = $(this);
                    $('.nav').addClass('nav-bg');

                    // Pokud je kliknuto na jiný odkaz než ten poslední dotknutý
                    if (lastTouchedLink && !$this.is(lastTouchedLink)) {
                        lastTouchedLink.removeData('touched'); // Odstraníme 'data-touched' z předchozího odkazu
                        lastTouchedLink.parent().removeClass('active');
                    }


                    // Pokud odkaz nemá atribut 'data-touched', přidej ho a zruš defaultní chování odkazu
                    if (!$this.data('touched')) {
                        e.preventDefault(); // Zruší defaultní akci odkazu
                        $this.data('touched', true); // Nastaví, že byl dotyk zaznamenán
                        $this.parent().addClass('active');
                        $('body').addClass('nav-overlay');
                        lastTouchedLink = $this; // Uloží odkaz jako poslední dotknutý

                        // Přidání event listeneru na dokument
                        $(document).on('touchstart.outsideLink', function(event) {
                            // Pokud uživatel klikne mimo poslední dotknutý odkaz
                            if (!$(event.target).is(lastTouchedLink)) {
                                lastTouchedLink.removeData('touched'); // Odstraní data-touched
                                lastTouchedLink.parent().removeClass('active');
                                lastTouchedLink = null;
                                $('body').removeClass('nav-overlay');
                                $('.nav').removeClass('nav-bg');

                                // Odeber event listener, už není potřeba
                                $(document).off('touchstart.outsideLink');
                            }
                        });
                    }
                });

            })
        }
    }


    //---------------------
    // On load functions
    //---------------------
    $(window).on('load',function() {
        setNavOffset();
        onTouchNav();
        if ($(document).scrollTop() === 0 ) {
            $('.nav').addClass("nav--top");
        }
    });


    //---------------------
    // On resize functions
    //---------------------
    var windowWidth = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == windowWidth) return;
        windowWidth = $(window).width();
        // navAnimationClasses();
        setNavOffset();
    });


})(jQuery);